export default function AdBanner({ ad }) {
  return (
    <div style={{
      background: ad.bg, borderRadius: 12, padding: "18px 22px",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      gap: 12, marginBottom: 16, border: `1px solid ${ad.accent}22`
    }}>
      <div>
        <div style={{ color: ad.accent, fontFamily: "'Oswald', sans-serif", fontSize: 13, letterSpacing: 1, marginBottom: 2 }}>SPONSORED</div>
        <div style={{ color: "#fff", fontFamily: "'Oswald', sans-serif", fontSize: 17, fontWeight: 700 }}>{ad.brand}</div>
        <div style={{ color: "#aaa", fontSize: 12, marginTop: 2 }}>{ad.tagline}</div>
      </div>
      <button style={{
        background: ad.accent, color: "#fff", border: "none", borderRadius: 8,
        padding: "9px 16px", fontFamily: "'Oswald', sans-serif", fontWeight: 700,
        fontSize: 13, cursor: "pointer", whiteSpace: "nowrap"
      }}>{ad.cta}</button>
    </div>
  );
}
